<template>

    <div class="w-full">

        <div class="w-full bg-red-600 text-white md:hidden py-2">
            <div class="w-full container mx-auto flex flex-wrap items-center max-w-5xl px-4">
                Metrics may not properly display on mobile devices.
            </div>
        </div>

        <div class="w-full container mx-auto flex flex-wrap items-center pb-3 md:pb-0 max-w-5xl mt-6 px-4">
            <div class="w-full mb-6 flex">
                <div>
                    <router-link to="/" class="text-blue-600">
                        Return to main site
                    </router-link>
                </div>
                <div class="flex-1 text-right text-gray-400">
                    {{ userInfo.name }}
                </div>
            </div>
            <div class="w-full">
                <h1 class="text-3xl font-semibold"><i class="far fa-chart-bar"></i> Metrics</h1>
            </div>
            <div class="w-full mt-2">
                <Card class="w-full mb-6">
                    <template v-slot:header>
                        Approved Videos
                        <i class="fas fa-info-circle ml-2 text-grey opacity-25" title="Number of videos approved" v-tippy></i>
                    </template>
                    <template v-slot:body>
                        <div class="p-2 md:p-6">
                            <calendar-heatmap :values="videosMetrics" :end-date="videosMetrics[videosMetrics.length-1]['date']" tooltip-unit="videos" v-if="videosMetricsLoaded" />
                            <h1 class="text-xl text-center" v-if="!videosMetricsLoaded"><i class="fa fa-circle-notch fa-spin"></i></h1>
                        </div>
                    </template>
                </Card>
            </div>
            <div class="w-full mt-2">
                <Card class="w-full mb-6">
                    <template v-slot:header>
                        Filtered Sales
                        <i class="fas fa-info-circle ml-2 text-grey opacity-25" title="Number of sales after filtering out package deals" v-tippy></i>
                    </template>
                    <template v-slot:body>
                        <div class="p-2 md:p-6">
                            <calendar-heatmap :values="salesMetrics" :end-date="salesMetrics[salesMetrics.length-1]['date']" tooltip-unit="sales" v-if="salesMetricsLoaded" />
                            <h1 class="text-xl text-center" v-if="!salesMetricsLoaded"><i class="fa fa-circle-notch fa-spin"></i></h1>
                        </div>
                    </template>
                </Card>
            </div>
            <div class="w-full text-sm text-gray-500 text-center">
                This is confidential, proprietary, and privileged information. Unauthorized disclosure or use is prohibited.
            </div>
            <div class="w-full text-sm text-gray-500 text-center">
                <PageFooter />
            </div>
        </div>
    </div>

</template>

<script>
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';
    import { EventBus } from '../../utils/events';
    import moment from 'moment';
    import { CalendarHeatmap } from 'vue-calendar-heatmap'
    import Card from '@/components/partials/Card'
    import PageFooter from '@/components/partials/PageFooter'


	export default {
		data () {
			return {
                videosMetrics: [],
                videosMetricsLoaded: false,
                salesMetrics: [],
                salesMetricsLoaded: false,
			}
        },
        components: {
            CalendarHeatmap,
            Card,
            PageFooter
        },
        mounted() {
            this.getVideoNumbers()
            this.getSalesMetrics()
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getVideoNumbers() {
                var _this = this
                this.$http.get(Config.apiPath + "/api/v2/metrics/videos", this.getAuthorizationHeader()).then((response) => {
                    this.$set(this, 'videosMetrics', response.data)
                    this.$set(this, 'videosMetricsLoaded', true)
                });
            },
            getSalesMetrics() {
                var _this = this
                this.$http.get(Config.apiPath + "/api/v2/metrics/sales", this.getAuthorizationHeader()).then((response) => {
                    this.$set(this, 'salesMetrics', response.data)
                    this.$set(this, 'salesMetricsLoaded', true)
                });
            },
            sortMetricData(inputArr) {
                return inputArr.sort((a,b) => b.count - a.count); 
            }
        },
        filters: {
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm A');
            },
        },
        computed: {
			...mapGetters([
                'userInfo',
            ]),
        },
	}
</script>

<style scoped>

    body {
        background-color: #EFF1F3;
    }

    .h-100 {
        min-height: 100vh;
    }

    .container-fluid {
        height: 100%;
    }

    .card {
        margin-bottom: 20px;
    }

    .card-block {
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 auto;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        padding: 1.25rem;
    }

    a:hover {
        text-decoration: none;
    }

    .actionable {
        color: #007bff;
        cursor: pointer;
    }

</style>
